import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { Bubble, Select, Modal, Button } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import useFilterSaveHook from '@/pages/intelligence/hooks/useFilterSaveHook';
import useFilterUseHook from '@/pages/intelligence/hooks/useFilterUseHook';
import { useDispatch } from 'umi';
import EllipsisHover from '@/pages/home/components/EllipsisHover';
import './index.scss';
import { FILTER_NAMESPACE } from '@/pages/intelligence/models/filter';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';

type OptionType = {
  value: string;
  text: React.ReactElement;
  context: string;
};

export default function FilterSelect(props: any) {
  // 把目前选择的值存到model里
  // 1 操作下拉的时候， 设置值到Model
  // 2 save的时候，设置值到Model
  // 3 操作其他筛选器的时候，把Model的值清空

  const {
    style,
    className,
    onChange,
    value: valueProps,
    filterSaveType = '',
    getFilterSaveListActionType = `${FILTER_NAMESPACE}/getFilterSaveListTrends`,
    getFilterSaveListActionPayload = {},
    useFilterSaveListByType = false,
  } = props;
  const { formatMessage, locale } = useIntlExtend();

  const { filterData } = useFilterSaveHook({
    filterSaveType,
    useFilterSaveListByType,
  });
  const { onRemoveFilterMsg } = useFilterUseHook({ filterSaveType });
  const [value, setValue] = useState(valueProps);
  const [visible, setVisible] = useState(false);
  const [options, setOptions] = useState<OptionType[]>([]);
  const [delectValue, setDelectValue] = useState('');

  const dispatch = useDispatch();

  useEffect(() => {
    setValue(valueProps);
  }, [valueProps]);

  useEffect(() => {
    if (filterSaveType !== '') {
      dispatch({
        type: getFilterSaveListActionType,
        payload: getFilterSaveListActionPayload,
      });
    }
  }, []);

  useEffect(() => {
    if (Array.isArray(filterData)) {
      const newOptions = filterData.map((item) => {
        const { name } = item;
        return {
          value: name,
          text: (
            <div className="dbi-select-filter-tab">
              <EllipsisHover placement="right" placementOffset={50} text={name}></EllipsisHover>
              {/* <span className="tab-text">{name}</span> */}
              <Bubble dark content={formatMessage({ id: 'dbi_filterSave_icon_delect' })}>
                <i
                  className="tab-icon"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                    setDelectValue(name);
                    setVisible(true);
                  }}
                >
                  <SvgIcon type="clear-icon" />
                </i>
              </Bubble>
            </div>
          ),
          context: name,
        };
      });
      setOptions(newOptions);
    }
  }, [JSON.stringify(filterData), locale]);

  const onClose = () => {
    setDelectValue('');
    setVisible(false);
  };
  return (
    <>
      <Select
        style={style}
        className={classnames('dbi-select-filter dbi-dbi-select-filter', className)}
        appearance="button"
        boxClassName="dbi-select-filter-box"
        searchable
        listWidth={271}
        listHeight={220}
        options={options}
        autoClearSearchValue
        searchPlaceholder={formatMessage({
          id: 'dbi_filterSave_my_filter_search',
        })}
        value={value}
        onChange={(value) => {
          onChange && onChange(value);
          setValue(value);
        }}
        footer={
          options?.length >= 10 ? (
            <div className="dbi-searchbox-label">{formatMessage({ id: 'dbi_filterSave_my_filter_top10' })}</div>
          ) : undefined
        }
        placeholder={formatMessage({ id: 'dbi_filterSave_my_filter' })}
        button={
          <div className="dbi-select-filter-flex">
            <SvgIcon type="funnel" className="dbi-select-filter-icon" />
            {!value ? (
              <span className="dbi-select-filter-text">{formatMessage({ id: 'dbi_filterSave_my_filter' })}</span>
            ) : (
              <span className="action-text">
                {
                  options.filter((e) => {
                    return e?.value === value;
                  })[0]?.context
                }
              </span>
            )}
          </div>
        }
      />
      <Modal visible={visible} caption="" onClose={onClose}>
        <Modal.Body>
          <div className="dbi-deleteSetting-title">{formatMessage({ id: 'dbi_filterSave_delete_info' })}</div>
          <div className="dbi-deleteSetting-desc">{formatMessage({ id: 'dbi_filterSave_do_delete' })}</div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="primary"
            onClick={() => {
              // 调用删除接口
              onRemoveFilterMsg(delectValue);
              // 筛选器方案下拉改为初始状态
              if (value === delectValue) {
                setValue('');
              }
              onClose();
            }}
          >
            {formatMessage({ id: 'common_confirm' })}
          </Button>
          <Button type="weak" onClick={onClose}>
            {formatMessage({ id: 'common_cancel' })}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
